export const generateDate = dateStr => {
  if (!dateStr) return '';
  return new Date(dateStr)
    .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    .split('/')
    .join(' ');
};
